"use client";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { FacebookIcon, InstagramIcon, TelegramIcon } from "./ui/icons";

export function Footer() {
  const pathname = usePathname();

  if (pathname.startsWith("/dashboard")) {
    return null;
  }
  return (
    <footer className="bg-gray-900 text-white py-12 relative bottom-0 mt-auto">
      <div className="container px-4 md:px-6">
        <div className="flex flex-row justify-between  ">
          <div>
            <h3 className="text-lg font-semibold mb-4">Nutriolift</h3>
            <ul className="space-y-2">
              <li>
                <Link
                  href="/sobre-nosotros"
                  className="hover:text-primary-hover"
                >
                  Sobre Nosotros
                </Link>
              </li>
              <li>
                <Link href="/contacto" className="hover:text-primary-hover">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <Link href="/aviso-legal" className="hover:text-primary-hover">
                  Aviso Legal
                </Link>
              </li>
              <li>
                <Link
                  href="/terminos-y-condiciones"
                  className="hover:text-primary-hover"
                >
                  Términos y Condiciones
                </Link>
              </li>
              <li>
                <Link
                  href="/politica-de-privacidad"
                  className="hover:text-primary-hover"
                >
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link
                  href="/politica-de-cookies"
                  className="hover:text-primary-hover"
                >
                  Política de Cookies
                </Link>
              </li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Síguenos</h3>
            <div className="flex space-x-4">
              <a
                href="https://www.facebook.com/share/RKDhoh6HCjP37RZ6/?mibextid=LQQJ4d"
                className="text-white hover:text-primary-hover"
              >
                <FacebookIcon className="h-6 w-6" />
              </a>

              <a
                href="https://instagram.com/nutriolift"
                className="text-white hover:text-primary-hover"
              >
                <InstagramIcon className="h-6 w-6" />
              </a>
              <a
                href="https://t.me/+3_x-GLMkw21kZTlk"
                className="text-white hover:text-primary-hover"
              >
                <TelegramIcon className="h-6 w-6" />
              </a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-8 border-t border-gray-700 text-center">
          <p className="text-sm">
            © 2025 NUTRIOLIFT. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
}
